import { Injectable } from '@angular/core';
import alertify from 'alertifyjs';

@Injectable({
  providedIn: 'root'
})
export class AlertifyService {

  constructor() { }

  // Success Notification
  success(message: string) {
    alertify.success(message);
  }

  // Error Notification
  error(message: string) {
    alertify.error(message);
  }

  // Warning Notification
  warning(message: string) {
    alertify.warning(message);
  }

  // Simple Alert Dialog
  alert(title: string, message: string, callback?: () => any) {
    alertify.alert(title, message, () => {
      if (callback) callback();
    });
  }

  // Confirmation Dialog
  confirm(title: string, message: string, okCallback: () => any, cancelCallback?: () => any) {
    alertify.confirm(title, message, 
      () => { okCallback(); },
      () => { if (cancelCallback) cancelCallback(); }
    );
  }
}
